import { map, Observable, withLatestFrom } from 'rxjs';
import { Action } from 'redux';
import { ofType } from 'src/core/engine/rxjs/ofType';
import { StorageMsg, StorageActions } from 'src/core/engine';

import { Actions, STORAGE_KEY_CART } from '../cart.actions';
import { AppendState, CartState } from '../cart.reducer';

const ONE_DAY = 60 * 60 * 24 * 1000;

export function cartPersist(action$: Observable<any>, state$: Observable<AppendState>): Observable<Action> {
    return action$.pipe(
        ofType<Actions>('Cart.Persist'),
        withLatestFrom(state$.pipe(map((s) => s.cart))),
        map(([, cart]: [Actions, CartState]) => {
            // Items to *never* persist
            const { deleting, updating, messages, itemMessages, status, ...rest } = cart;
            return StorageMsg(StorageActions.Set, {
                key: STORAGE_KEY_CART,
                value: rest,
                expiry: new Date().getTime() + ONE_DAY,
            });
        }),
    );
}
